import apiClient from "./httpClient";
import endpoints from "./endpoints";

export const getPeopleCounterOrganizations = (config = {}) =>
  apiClient.get(endpoints.peopleCounter.organizations(), config);

export const getPeopleCounterDevices = (params, config = {}) =>
  apiClient.get(endpoints.peopleCounter.devices(), { ...config, params });

export const getPeopleCounterDeviceOptions = (params, config = {}) =>
  apiClient.get(endpoints.peopleCounter.deviceOptions(), { ...config, params });

export const createPeopleCounterDevice = (payload) =>
  apiClient.post(endpoints.peopleCounter.devices(), payload);

export const updatePeopleCounterDevice = (id, payload) =>
  apiClient.put(endpoints.peopleCounter.device(id), payload);

export const deletePeopleCounterDevice = (id) =>
  apiClient.delete(endpoints.peopleCounter.device(id));

export const setPeopleCounterLineVisibility = (id, payload) =>
  apiClient.patch(endpoints.peopleCounter.lineVisibility(id), payload);

export const getOnePeopleCounterStatistics = (peopleCounterId, config = {}) =>
  apiClient.get(endpoints.peopleCounter.statisticsOne(), {
    ...config,
    params: { peopleCounterId },
  });

export const getManyPeopleCounterStatistics = (payload, config = {}) =>
  apiClient.post(endpoints.peopleCounter.statisticsMany(), payload, config);

export const getLatestPeopleCounterStatistics = (payload, config = {}) =>
  apiClient.post(endpoints.peopleCounter.statisticsLatest(), payload, config);

export const getPeopleCounterRealtimeConfig = (config = {}) =>
  apiClient.get(endpoints.peopleCounter.realtimeConfig(), config);

export const exportPeopleCounterReport = (payload, config = {}) =>
  apiClient.post(endpoints.peopleCounter.statisticsExport(), payload, {
    ...config,
    responseType: "blob",
  });
